import React, { FC } from 'react';
import Stack from '@mui/material/Stack';

import { MessageCenterListHeader } from './MessageCenterListHeader';
import { MessageCenterListSearch } from './MessageCenterListSearch';
import { MessageCenterListTabs } from './MessageCenterListTabs';

export const MessageCenterList: FC = () => {
  return (
    <Stack direction="column" flex={1} gap={4} minHeight={0}>
      <MessageCenterListHeader />
      <MessageCenterListSearch />
      <MessageCenterListTabs />
    </Stack>
  );
};
